// Plain words for stored values (UI review slice 5). Wording only: the
// stored values and their meaning are unchanged.

import type { EntityKind, MembershipRole } from "./types";

export const ROLE_LABEL: Record<MembershipRole, string> = {
  owner: "owner",
  lead_assessor: "lead assessor",
  assessor: "assessor",
  viewer: "viewer",
};

export const ENTITY_KIND_LABEL: Record<EntityKind, string> = {
  portfolio: "portfolio",
  program: "program",
  project: "project",
  pmo_function: "PMO function",
};
